var _circle, _circle2, _path, _rect, _rect2, _rect3, _rect4, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdeaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 28,
    fill: "#FFF17C",
    stroke: "black",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 32,
    r: 9,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 37H34V39.5C34 41.9853 31.9853 44 29.5 44V44C27.0147 44 25 41.9853 25 39.5V37Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 45,
    width: 8,
    height: 2,
    rx: 1,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 30,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 18.5,
    width: 6,
    height: 3,
    rx: 1.5,
    transform: "rotate(-90 28.5 18.5)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5399 18.2085C17.1982 17.5025 18.3043 17.4639 19.0103 18.1222L20.9278 19.9103C21.6338 20.5687 21.6724 21.6747 21.014 22.3807V22.3807C20.3557 23.0867 19.2496 23.1254 18.5436 22.467L16.6261 20.6789C15.9201 20.0205 15.8815 18.9145 16.5399 18.2085V18.2085Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2997 18.2085C42.6414 17.5025 41.5353 17.4639 40.8293 18.1222L38.9118 19.9103C38.2058 20.5687 38.1672 21.6747 38.8256 22.3807V22.3807C39.4839 23.0867 40.59 23.1254 41.296 22.467L43.2135 20.6789C43.9195 20.0205 43.9581 18.9145 43.2997 18.2085V18.2085Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaIcon);
export default __webpack_public_path__ + "static/media/idea-icon.1934a1a980ecd979dfe57dd767320e96.svg";
export { ForwardRef as ReactComponent };